var RoomBuilderErrors = {
  general: function (errors) {
    var err = [];

    if (errors.identifier && errors.identifier.length) {
      for (var i = 0, ilen = errors.identifier.length; i < ilen; i++) {
        err.push(I18n.t("room_identifier") + " " + errors.identifier[i]);
      }
    }
    return err;
  },

  room_type: function (errors) {
    var err = [];

    if (errors.room_type && errors.room_type.length) {
      for (var i = 0, ilen = errors.room_type.length; i < ilen; i++) {
        err.push(errors.room_type[i]);
      }
    }
    return err;
  },
};

export default RoomBuilderErrors;
